<app-navbar />
<div class="container-fluid">

	<div class="panel modern-card">
		<!-- Modal de reatribuição -->
		<div class="modal-overlay" *ngIf="showReatribuirModal">
			<div class="modal-card">
				<h4>Reatribuir ordem</h4>
				<p>Selecione o vistoriante para reatribuir a ordem:</p>
				<div *ngIf="carregandoColaboradores" class="text-center">Carregando colaboradores...</div>
				<div *ngIf="!carregandoColaboradores">
					<select class="form-select" [(ngModel)]="selectedColaboradorId">
						<option [ngValue]="null">-- selecione --</option>
						<option *ngFor="let col of colaboradores" [value]="col.usuarioId">{{ col.matricula }} - {{
							col.nome }}</option>
					</select>
				</div>
				<div class="modal-actions">
					<button class="btn btn-secondary" (click)="closeReatribuirModal()">Cancelar</button>
					<button class="btn btn-primary" (click)="confirmReatribuir()"
						[disabled]="actionLoading[reatribuirOrder?.ordemServicoId]">Confirmar</button>
				</div>
			</div>
		</div>

		<!-- Modal de desatribuição -->
		<div class="modal-overlay" *ngIf="showDesatribuirModal">
			<div class="modal-card">
				<h4>Confirmar desatribuição</h4>
				<p>
					Deseja realmente desatribuir a vistoria 
					<strong>
						{{ desatribuirOrder?.numeroOrdemFormatado || desatribuirOrder?.numeroOrdem || '---' }}
					</strong>?
				</p>
				<p class="text-muted small">
					O vistoriante <strong>{{ usuariosMap[desatribuirOrder?.usuarioId]?.nome || '---' }}</strong> será removido e a vistoria voltará para não atribuída.
				</p>
				<div class="modal-actions">
					<button class="btn btn-secondary" (click)="closeDesatribuirModal()">Cancelar</button>
					<button class="btn btn-warning" (click)="confirmDesatribuir()"
						[disabled]="actionLoading[desatribuirOrder?.ordemServicoId]">Confirmar Desatribuição</button>
				</div>
			</div>
		</div>

		<!-- Modal batch reatribuir -->
		<div class="modal-overlay" *ngIf="showReatribuirBatchModal">
			<div class="modal-card">
				<h4>Reatribuir ordens selecionadas ({{ selectedCount }})</h4>
				<p>Selecione o vistoriante para reatribuir as ordens selecionadas:</p>
				<div *ngIf="carregandoColaboradores" class="text-center">Carregando colaboradores...</div>
				<div *ngIf="!carregandoColaboradores">
					<select class="form-select" [(ngModel)]="selectedColaboradorIdBatch">
						<option [ngValue]="null">-- selecione --</option>
						<option *ngFor="let col of colaboradores" [value]="col.usuarioId">{{ col.matricula }} - {{ col.nome }}</option>
					</select>
				</div>
				<div class="modal-actions">
					<button class="btn btn-secondary" (click)="closeReatribuirBatchModal()">Cancelar</button>
					<button class="btn btn-primary" (click)="confirmReatribuirBatch()">Confirmar</button>
				</div>
			</div>
		</div>

		<!-- Modal batch desatribuir -->
		<div class="modal-overlay" *ngIf="showDesatribuirBatchModal">
			<div class="modal-card">
				<h4>Confirmar desatribuição em lote</h4>
				<p>Deseja realmente desatribuir as {{ selectedCount }} ordens selecionadas?</p>
				<div class="modal-actions">
					<button class="btn btn-secondary" (click)="closeDesatribuirBatchModal()">Cancelar</button>
					<button class="btn btn-warning" (click)="confirmDesatribuirBatch()">Confirmar Desatribuição</button>
				</div>
			</div>
		</div>

		<div class="panel-body">

			<!-- Modal: Alterar status (SuperAdministrador) - colocado em nível do panel para garantir overlay correto -->
			<div class="modal-overlay" *ngIf="showChangeStatusModal">
				<div class="modal-card">
					<h4>Alterar status</h4>
					<p>Selecione o novo status:</p>
					<div class="mb-2">
						<select class="form-select" [(ngModel)]="changeSelectedStatus">
							<option [value]="'Pendente'">Pendente</option>
							<option [value]="'Ausente'">Retornar</option>
							<option [value]="'Concluida'">Concluída</option>
							<option [value]="'Negada'">Negada</option>
						</select>
					</div>
					<div *ngIf="changeSelectedStatus === 'Negada'" class="mb-2">
						<label class="form-label">Motivo da negação</label>
						<textarea class="form-control" [(ngModel)]="changeMotivo" rows="3"
							placeholder="Informe o motivo (mínimo 10 caracteres)" maxlength="500"></textarea>
					</div>
					<div class="mb-2 text-danger"
						*ngIf="changeSelectedStatus === 'Negada' && (!changeMotivo || (changeMotivo && changeMotivo.trim().length < 10))">
						Motivo obrigatório: informe pelo menos 10 caracteres quando o status for "Negada".
					</div>
					<div class="modal-actions">
						<button class="btn btn-secondary" (click)="closeChangeStatusModal()">Cancelar</button>
						<button class="btn btn-primary" (click)="confirmChangeStatus()"
							[disabled]="changeLoading[changeTarget?.ordemServicoId || changeTarget?.id || 'unknown'] || (changeSelectedStatus === 'Negada' && (!(changeMotivo && changeMotivo.trim().length >= 10)))">
							Confirmar
						</button>
					</div>
				</div>
			</div>
			<!-- Filtros (adopted design from servicos) -->
			<div class="card filtros-modernas border-0 mb-4">
				<div class="card-header d-flex align-items-center rounded-top">
					<i class="fas fa-search fs-5 me-2"></i>
					<h2 class="fw-bold">Vistoria</h2>
				</div>
				<div class="card-body">
					<div class="row" *ngIf="!error">
						<div
							class="top-controls compact-controls d-flex flex-wrap align-items-center justify-content-between w-100">
							<div class="d-flex gap-2 align-items-center">
								<button class="btn btn-info btn-sm" type="button" (click)="showFiltros = !showFiltros">
									<i class="fas fa-filter"></i> Filtrar
								</button>
								<!-- seleção em massa -->
								<div *ngIf="selectedCount > 0" class="selection-bar ms-2 d-flex align-items-center gap-2">
									<span class="small selection-count">Selecionados: <strong>{{ selectedCount }}</strong></span>
									<button class="btn btn-sm btn-reatribuir me-1" (click)="openReatribuirBatchModal()" [disabled]="!allSelectedHaveStatusIn(['Pendente','Retornar','Concluida','Negada'])">Reatribuir selecionados</button>
									<button class="btn btn-sm btn-desatribuir me-1" (click)="openDesatribuirBatchModal()" [disabled]="!(isSuperAdministrador && allSelectedHaveStatusIn(['Pendente']))">Desatribuir selecionados</button>
									<button class="btn btn-sm btn-limpar" (click)="clearSelection()">Limpar seleção</button>
								</div>
							</div>

							<!-- Período -->
							<div class="d-flex align-items-center gap-2 me-3">
								<input class="form-control form-control-sm period-input" type="date"
									[(ngModel)]="filtroDataInicio" />
								<span>até</span>
								<input class="form-control form-control-sm period-input" type="date"
									[(ngModel)]="filtroDataFim" (change)="onDataFimChange()" />
								<div>
									<button class="btn btn-primary" (click)="aplicarFiltros()">Recarregar</button>
								</div>
							</div>

							<!-- Itens por página + Paginação -->
							<div class="d-flex align-items-center gap-2 ms-auto">
								<label class="mb-0 small">Itens:</label>
								<select id="tamanhoPaginaSelect" class="form-select form-select-sm"
									[(ngModel)]="tamanhoPagina" (ngModelChange)="alterarTamanhoPagina($event)">
									<option [value]="5">5</option>
									<option [value]="10">10</option>
									<option [value]="25">25</option>
									<option [value]="50">50</option>
									<option [value]="100">100</option>
								</select>

								<span class="page-info small">Página {{paginaAtual}} de {{totalPaginas}} ({{totalItens}}
									itens)</span>

								<button class="btn btn-outline-secondary btn-sm" (click)="paginaAnterior()"
									[disabled]="paginaAtual <= 1">
									<i class="fas fa-chevron-left"></i>
								</button>
								<button class="btn btn-outline-secondary btn-sm" (click)="proximaPagina()"
									[disabled]="paginaAtual >= totalPaginas">
									<i class="fas fa-chevron-right"></i>
								</button>
							</div>
						</div>
					</div>

					<!-- Filtros expansíveis -->
					<div class="row mt-2" [ngClass]="{ 'd-none': !showFiltros }">
						<div class="col-md-3">
							<label class="form-label">Status</label>
							<select class="form-select" [(ngModel)]="filtroStatus">
								<option value="">Todos</option>
								<option value="Pendente">Pendente</option>
								<option value="EmAndamento">Em Andamento</option>
								<option value="Concluida">Concluída</option>
								<option value="Cancelada">Cancelada</option>
								<option value="Retornar">Retornar</option>
								<option value="Negada">Negada</option>
							</select>
						</div>

						<div class="col-md-3">
							<label class="form-label">Vistoriante</label>
							<div *ngIf="carregandoColaboradores" class="text-center">Carregando colaboradores...</div>
							<div *ngIf="!carregandoColaboradores">
								<select class="form-select" [(ngModel)]="filtroUsuarioId">
									<option [ngValue]="null">Todos</option>
									<option *ngFor="let col of colaboradores" [ngValue]="col.usuarioId">{{ col.matricula }} - {{ col.nome }}</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<label class="form-label">Matrícula</label>
							<input type="text" class="form-control" [(ngModel)]="filtroMatricula"
								placeholder="Matrícula do consumidor" />
						</div>
						<div class="col-md-3">
							<label class="form-label">Nº Vistoria</label>
							<input type="number" class="form-control" [(ngModel)]="filtroNumeroOrdem"
								placeholder="Nº Vistoria" />
						</div>
						<div class="col-md-3">
							<label class="form-label">Nome Consumidor</label>
							<input type="text" class="form-control" [(ngModel)]="filtroNomeConsumidor"
								placeholder="Nome do consumidor" />
						</div>
						<div class="col-md-3 mt-2">
							<label class="form-label">CPF</label>
							<input type="text" class="form-control" [(ngModel)]="filtroCpf" placeholder="CPF" />
						</div>
						<div class="col-md-3 mt-2">
							<label class="form-label">CNPJ</label>
							<input type="text" class="form-control" [(ngModel)]="filtroCnpj" placeholder="CNPJ" />
						</div>
						<div class="col-md-3 mt-2">
							<label class="form-label">CEP</label>
							<input type="text" class="form-control" [(ngModel)]="filtroCep" placeholder="CEP" />
						</div>
						<div class="col-md-3 mt-2">
							<label class="form-label">Número</label>
							<input type="text" class="form-control" [(ngModel)]="filtroNumero"
								placeholder="Número (logradouro)" />
						</div>
						<div class="col-md-3 mt-2">
							<label class="form-label">Logradouro</label>
							<input type="text" class="form-control" [(ngModel)]="filtroLogradouro"
								placeholder="Logradouro" />
						</div>
						<div class="col-md-3 mt-2">
							<label class="form-label">Bairro</label>
							<input type="text" class="form-control" [(ngModel)]="filtroBairro" placeholder="Bairro" />
						</div>
						<div class="col-md-3 mt-2">
							<label class="form-label">Cidade</label>
							<input type="text" class="form-control" [(ngModel)]="filtroCidade" placeholder="Cidade" />
						</div>
						<div class="col-md-3 mt-2">
							<label class="form-label">Estado</label>
							<input type="text" class="form-control" [(ngModel)]="filtroEstado" placeholder="Estado" />
						</div>
						<div class="col-12 mt-3 d-flex gap-2">
							<button class="btn btn-primary" (click)="aplicarFiltros()">Aplicar filtros</button>
							<button class="btn btn-secondary" (click)="resetFiltros()">Limpar e Recarregar</button>
						</div>
					</div>
				</div>
			</div>

			<!-- Loading spinner -->
			<div *ngIf="loading" class="carregando-container modern-loader">
				<div class="modern-spinner"></div>
				<p>Carregando Vistoria...</p>
			</div>

			<!-- Error message -->
			<div *ngIf="error" class="erro-container modern-error">
				<i class="fas fa-exclamation-triangle"></i>
				<p>{{ error }}</p>
			</div>

			<!-- No results message -->
			<div *ngIf="!loading && !error && (!ordens || ordens.length === 0)" class="sem-resultados modern-empty">
				<i class="fas fa-info-circle"></i>
				<p>Nenhuma vistoria encontrada.</p>
			</div>

			<!-- Table of ordens de vistoria -->
			<div *ngIf="!loading && !error && ordens && ordens.length > 0"
				class="table-container modern-table-container">
				<div class="table-responsive modern-table-container">
					<table class="table table-hover table-bordered modern-table align-middle">
						<thead class="table-light modern-header ">
							<tr>
								<th style="width:36px; text-align:center;">
									<input type="checkbox" [checked]="selectedCount===ordens.length" (click)="$event.stopPropagation(); selectAllToggle($event)" />
								</th>
								<th>
									<span class="th-icon-label justify-content-center">
										<span>Vistoria</span>
									</span>
								</th>
								<th>
									<span class="th-icon-label justify-content-center ">
										<span>Nome</span>
									</span>
								</th>
								<th>
									<span class="th-icon-label justify-content-center">
										<span>Status</span>
									</span>
								</th>
								<th>
									<span class="th-icon-label justify-content-center">
										<span>Data</span>
									</span>
								</th>
								<th>
									<span class="th-icon-label justify-content-center">
										<span>Endereço</span>
									</span>
								</th>
								<th>
									<span class="th-icon-label justify-content-center">
										<span>Vistoriante</span>
									</span>
								</th>
								<th class="actions-col">
									<span class="th-icon-label">
										<span>Ações</span>
									</span>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let ordem of ordens; let i = index" (click)="toggleSelectOrdem(ordem, $event)" [ngClass]="{'selected-row': selectedOrdens.has(ordem.ordemServicoId)}">
								<td style="text-align:center; width:36px;" (click)="$event.stopPropagation()">
									<input type="checkbox" (change)="toggleSelectOrdem(ordem, $event)" [checked]="selectedOrdens.has(ordem.ordemServicoId)" />
								</td>
								<td class="ordem-numero-cell" style="width:85px; font-size:0.85rem; text-align:center;">
									{{
									ordem.numeroOrdemFormatado || ordem.numeroOrdem || '-' }}</td>
								<td class="ordem-nome-cell">{{ ordem.nomeConsumidor || '-' }}</td>
								<td class="justify-content-center" (click)="openChangeStatusModal(ordem, $event)">
									<span [ngClass]="{
										'badge badge-pendente': ordem.status === 'Pendente',
										'badge badge-em-andamento': ordem.status === 'EmAndamento',
										'badge badge-concluida': ordem.status === 'Concluida',
										'badge badge-reatribuida': ordem.status === 'Reatribuida',
										'badge badge-cancelada': ordem.status === 'Cancelada',
										'badge badge-negada': ordem.status === 'Negada',
										'badge badge-retornar': ordem.status === 'Retornar',
										'badge bg-secondary': !ordem.status
									}" [attr.title]="currentUserRole === 'SuperAdministrador' ? 'Clique para alterar status' : null"
										(click)="openChangeStatusModal(ordem, $event)" style="cursor: pointer;">
										{{ ordem.status || '-' }}
									</span>
								</td>
								<td class="ordem-data-cell">
									<ng-container *ngIf="ordem.dataDistribuicao; else semData">
										<div class="ordem-data">{{ ordem.dataDistribuicao | date:'dd/MM/yyyy' }}</div>
										<div class="ordem-time">{{ ordem.dataDistribuicao | date:'HH:mm' }}</div>
									</ng-container>
									<ng-template #semData>-</ng-template>
								</td>
								<td>
									<span *ngIf="ordem.endereco; else semEndereco" class="ordem-endereco">
										{{ ordem.endereco?.logradouro || '-' }},
										{{ ordem.endereco?.bairro || '-' }},
										{{ ordem.endereco?.localidade || ordem.endereco?.cidade || '-' }},
										{{ ordem.endereco?.cep || '-' }}
									</span>
									<ng-template #semEndereco>-</ng-template>
								</td>
								<td>
									<div class="d-flex align-items-center gap-2">
									<span class="vistoriante-nome">{{ formatarNomeVistoriante(usuariosMap[ordem.usuarioId]?.nome) }}</span>
								</div>
							</td>

								<td class="text-center ver actions-col" style="height: auto !important;">
									<div class="action-menu-wrapper">
										<!-- Direct action: for Pendente show Cancelar (admins), otherwise show Visualizar -->
										<button class="action-menu-btn action-direct" aria-label="Ação"
											(click)="$event.stopPropagation(); ordem.status === 'Pendente' && (currentUserRole == 'Administrador' || currentUserRole == 'SuperAdministrador') ? triggerCancelFromMenu(ordem, $event) : triggerVerFromMenu(ordem, $event)"
											[disabled]="actionLoading[ordem.ordemServicoId] || viewLoading[ordem.ordemServicoId]"
											[title]="ordem.status === 'Pendente' ? 'Cancelar' : 'Visualizar'">
											<ng-container *ngIf="ordem.status === 'Pendente' && (currentUserRole == 'Administrador' || currentUserRole == 'SuperAdministrador')">
												<ng-container *ngIf="!actionLoading[ordem.ordemServicoId]; else cancelLoadingIcon">
													<i class="fas fa-times action-cancel"></i>
												</ng-container>
												<ng-template #cancelLoadingIcon>
													<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
												</ng-template>
											</ng-container>
											<ng-container *ngIf="ordem.status !== 'Pendente'">
												<ng-container *ngIf="!viewLoading[ordem.ordemServicoId]; else verLoadingIcon">
													<i class="fas fa-eye action-view"></i>
												</ng-container>
												<ng-template #verLoadingIcon>
													<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
												</ng-template>
											</ng-container>
										</button>
										<!-- indicador de loading persistente na célula de ações -->
										<div class="action-inline-spinner"
											*ngIf="viewLoading[ordem.ordemServicoId] || actionLoading[ordem.ordemServicoId]">
											<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
										</div>
									</div>
								</td>

								<!-- Modal dng se confirmação de cancelamento -->
								<div class="modal-overlay" *ngIf="showCancelModal">
									<div class="modal-card">
										<h4>Confirmar cancelamento</h4>
										<p>
											Deseja realmente cancelar a vistoria de
											<strong>
												{{ cancelingOrder?.matricula && cancelingOrder?.matricula !== '-' ?
												cancelingOrder.matricula : (usuariosMap[cancelingOrder?.usuarioId]?.nome
												|| cancelingOrder?.nomeConsumidor || '---') }}
											</strong>
											?
										</p>
										<div class="modal-actions">
											<button class="btn btn-secondary"
												(click)="closeCancelModal()">Cancelar</button>
											<button class="btn btn-danger" (click)="confirmCancel()"
												[disabled]="actionLoading[cancelingOrder?.ordemServicoId]">Confirmar</button>
										</div>
									</div>


								</div>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>